import { size as _size } from 'lodash'


export const types = {
  SET_BIND_CARD: 'userCards/SET_BIND_CARD',

  USER_CARD_GET_REQUEST: 'userCards/USER_CARD_GET_REQUEST',
  USER_CARD_GET_COMPLETED: 'userCards/USER_CARD_GET_COMPLETED',
  USER_CARD_GET_FAILED: 'userCards/USER_CARD_GET_FAILED',

  // FunPoint
  FUNPOINT_TOKEN_GET_REQUEST: 'userCards/FUNPOINT_TOKEN_GET_REQUEST',
  FUNPOINT_TOKEN_GET_COMPLETED: 'userCards/FUNPOINT_TOKEN_GET_COMPLETED',
  FUNPOINT_TOKEN_GET_FAILED: 'userCards/FUNPOINT_TOKEN_GET_FAILED',
  FUNPOINT_CARD_ADD_REQUEST: 'userCards/FUNPOINT_CARD_ADD_REQUEST',
  FUNPOINT_CARD_ADD_COMPLETED: 'userCards/FUNPOINT_CARD_ADD_COMPLETED',
  FUNPOINT_CARD_ADD_FAILED: 'userCards/FUNPOINT_CARD_ADD_FAILED',
  FUNPOINT_CARD_REMOVE_REQUEST: 'userCards/FUNPOINT_CARD_REMOVE_REQUEST',
  FUNPOINT_CARD_REMOVE_COMPLETED: 'userCards/FUNPOINT_CARD_REMOVE_COMPLETED',
  FUNPOINT_CARD_REMOVE_FAILED: 'userCards/FUNPOINT_CARD_REMOVE_FAILED',
  
  // TapPay
  TAP_PAY_CAN_GET_PRIME: 'userCards/TAP_PAY_CAN_GET_PRIME',
  TAPPAY_CARD_ADD_LOADING: 'userCards/TAPPAY_CARD_ADD_LOADING',
  TAPPAY_CARD_ADD_REQUEST: 'userCards/TAPPAY_CARD_ADD_REQUEST',
  TAPPAY_CARD_ADD_COMPLETED: 'userCards/TAPPAY_CARD_ADD_COMPLETED',
  TAPPAY_CARD_ADD_FAILED: 'userCards/TAPPAY_CARD_ADD_FAILED',
  TAPPAY_CARD_REMOVE_REQUEST: 'userCards/TAPPAY_CARD_REMOVE_REQUEST',
  TAPPAY_CARD_REMOVE_COMPLETED: 'userCards/TAPPAY_CARD_REMOVE_COMPLETED',
  TAPPAY_CARD_REMOVE_FAILED: 'userCards/TAPPAY_CARD_REMOVE_FAILED',

  RESET: 'userCards/RESET',
}

const initialState = { 
  card_bound: false,
  // can_bind_card: false,

  three_d_url: undefined, // For card 3D Secure

  // FunPoint
  funpoint_form_token: null, // For card form
  funpoint_card_token: null, // For card binding
  
  // TapPay
  tap_pay_can_get_prime: false, // Check if the card info is valid to get prime
  tap_pay_status: undefined, // Status for non-3D secure transactions (1: success)
  tap_pay_card_add_loading: false, // Loading state for addCard button
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    // case types.SET_BIND_CARD: 
    //   return { ...state, can_bind_card: action.can_bind };

    case types.USER_CARD_GET_REQUEST:
    case types.USER_CARD_GET_FAILED:
    case types.FUNPOINT_TOKEN_GET_REQUEST:
    case types.FUNPOINT_TOKEN_GET_FAILED:
    case types.FUNPOINT_CARD_ADD_REQUEST:
    case types.FUNPOINT_CARD_ADD_FAILED:
    case types.FUNPOINT_CARD_REMOVE_REQUEST:
    case types.FUNPOINT_CARD_REMOVE_FAILED:
    case types.TAPPAY_CARD_REMOVE_REQUEST:
    case types.TAPPAY_CARD_REMOVE_FAILED:
      return { ...state };

    case types.USER_CARD_GET_COMPLETED:
      let cardBound = null;
      
      if (_size(action.data) && action.data.card && _size(action.data.card)) { 
        cardBound = action.data.card; 
      }
          
      return { ...state, card_bound: cardBound };

    case types.FUNPOINT_TOKEN_GET_COMPLETED:
      return { ...state, funpoint_form_token: action.data.token_data };

    case types.FUNPOINT_CARD_ADD_COMPLETED:
      return { ...state, three_d_url: action.data.redirect_url };
    
    case types.FUNPOINT_CARD_REMOVE_COMPLETED:
      return { ...state, card_bound: null };
    
    case types.TAP_PAY_CAN_GET_PRIME: 
      return { ...state, tap_pay_can_get_prime: action.can_get };

    case types.TAPPAY_CARD_ADD_LOADING:
      return { ...state, tap_pay_card_add_loading: action.loading };

    case types.TAPPAY_CARD_ADD_REQUEST:
      return { ...state, three_d_url: undefined, tap_pay_status: undefined };

    case types.TAPPAY_CARD_ADD_COMPLETED:
      return { ...state, three_d_url: action.data.payment_url, tap_pay_status: action.data.status, tap_pay_card_add_loading: false };

    case types.TAPPAY_CARD_ADD_FAILED:
      return { ...state, tap_pay_card_add_loading: false };
    
    case types.TAPPAY_CARD_REMOVE_COMPLETED:
      return { ...state, card_bound: null };

    case types.RESET:
      return { ...initialState };

    default: return state;
  }
}

export const actions = {
  setCanBindCard: function (canBind) {
    return { type: types.SET_BIND_CARD, can_bind: canBind };
  },
  
  getUserCardRequest: () => ({
    type: types.USER_CARD_GET_REQUEST,
  }),
  getUserCardCompleted: (data) => ({
    type: types.USER_CARD_GET_COMPLETED,
    data: data,
  }),
  getUserCardFailed: (error) => ({
    type: types.USER_CARD_GET_FAILED,
    error: error,
  }),

  // FunPoint
  getFunPointTokenRequest: (data) => ({
    type: types.FUNPOINT_TOKEN_GET_REQUEST,
    data: data,
  }),
  getFunPointTokenCompleted: (data) => ({
    type: types.FUNPOINT_TOKEN_GET_COMPLETED,
    data: data,
  }),
  getFunPointTokenFailed: (error) => ({
    type: types.FUNPOINT_TOKEN_GET_FAILED,
    error: error,
  }),
  addFunPointCardRequest: (data) => ({
    type: types.FUNPOINT_CARD_ADD_REQUEST,
    data: data,
  }),
  addFunPointCardCompleted: (data) => ({
    type: types.FUNPOINT_CARD_ADD_COMPLETED,
    data: data,
  }),
  addFunPointCardFailed: (error) => ({
    type: types.FUNPOINT_CARD_ADD_FAILED,
    error: error,
  }),
  removeFunPointCardRequest: (data) => ({
    type: types.FUNPOINT_CARD_REMOVE_REQUEST,
    data: data,
  }),
  removeFunPointCardCompleted: (data) => ({
    type: types.FUNPOINT_CARD_REMOVE_COMPLETED,
    data: data,
  }),
  removeFunPointCardFailed: (error) => ({
    type: types.FUNPOINT_CARD_REMOVE_FAILED,
    error: error,
  }),

  // TapPay
  setTapPayCanGetPrime: (canGet) => ({
    type: types.TAP_PAY_CAN_GET_PRIME,
    can_get: canGet,
  }),
  addTapPayCardLoading: (loading) => ({
    type: types.TAPPAY_CARD_ADD_LOADING,
    loading: loading,
  }),
  addTapPayCardRequest: (data) => ({
    type: types.TAPPAY_CARD_ADD_REQUEST,
    data: data,
  }),
  addTapPayCardCompleted: (data) => ({
    type: types.TAPPAY_CARD_ADD_COMPLETED,
    data: data,
  }),
  addTapPayCardFailed: (error) => ({
    type: types.TAPPAY_CARD_ADD_FAILED,
    error: error,
  }),
  removeTapPayCardRequest: (data) => ({
    type: types.TAPPAY_CARD_REMOVE_REQUEST,
    data: data,
  }),
  removeTapPayCardCompleted: (data) => ({
    type: types.TAPPAY_CARD_REMOVE_COMPLETED,
    data: data,
  }),
  removeTapPayCardFailed: (error) => ({
    type: types.TAPPAY_CARD_REMOVE_FAILED,
    error: error,
  }),

  reset: () => ({ type: types.RESET }),
}
